import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EventsService} from '../../events/events.service';
import {GlobalService} from '../../../global.service';
import {AuthenticationService} from '../../../authentication.service';

@Component({
  selector: 'elastic-join-r3e-server',
  templateUrl: './join-r3e-server.component.html',
  styleUrls: ['./join-r3e-server.component.scss']
})
export class JoinR3eServerComponent implements OnInit {
  selectedLivery = 0;
  selectedCar = 0;

  raceRoomContent = [];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private eventsService: EventsService,
              private globalServie: GlobalService, globalService: GlobalService,
              private auth: AuthenticationService,
              public dialogRef: MatDialogRef<JoinR3eServerComponent>) { }

  ngOnInit() {

    this.globalServie.getUserRaceRoomContent(this.auth.getUserId()).subscribe( (data:any) => {
      if (data) {
        this.raceRoomContent = data.content_ids;
      }
    });

  }

  join() {
    console.log(atob(this.data.link));

    //@ts-ignore
    document.location.href = atob(this.data.link).replace("LIVID", this.selectedLivery.toString());
    this.dialogRef.close();
  }

}
